import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTranslation, fetchCorrectTranslation } from '../../utils/translation';

const BaseFooter = ({ theme = 'basic' }) => {
  const { t } = useTranslation();

  const isTR2026 = theme === 'tr2026';

  // tr_2026 keys live at root — bypass getTranslation (which prepends teamType),
  // but still resolve the { ch, default } variant object via fetchCorrectTranslation
  const get = (subKey) => {
    if (isTR2026) {
      const raw = t(`tr_2026.baseFooter.${subKey}`, { returnObjects: true });
      return fetchCorrectTranslation(raw);
    }
    return getTranslation(t, `landing.baseFooter.${subKey}`);
  };

  return (
    <div className="flex bg-cgrey-300 text-sm justify-between py-7 sm:px-28 px-5">
      <div>
        <div dangerouslySetInnerHTML={{ __html: get('copyright') }} />
      </div>
      <div className="flex sm:gap-10 gap-4">
        <div className="cursor-pointer">
          <a href={get('imprint.link')} target="_blank" rel="noreferrer">
            <span dangerouslySetInnerHTML={{ __html: get('imprint.text') }} />
          </a>
        </div>
        <div className="cursor-pointer">
          <a href={get('disclaimer.link')} target="_blank" rel="noreferrer">
            <span dangerouslySetInnerHTML={{ __html: get('disclaimer.text') }} />
          </a>
        </div>
        <div className="cursor-pointer">
          <a href={get('dataProtection.link')} target="_blank" rel="noreferrer">
            <span dangerouslySetInnerHTML={{ __html: get('dataProtection.text') }} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default BaseFooter;
